var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useState, useEffect } from "react";
import Page from "@atlaskit/page";
import { Grid, GridColumn, ReactRouter, Spinner, useQuery } from "@atlassiansox/microscopekit";
import { isEmpty } from "lodash";
import { ActiveWargameForWargameExercise, EmptyExercise, ExerciseExperiments, ExercisePageHeader, ExerciseProgressTracker, ImportWargamePlan, RecentWargamesForExercise, WargamePlans, ExerciseBeingPrepared, ExecuteExperiments } from "../components";
import { WargameExerciseMasterDataQuery, WargamesInProgressQuery } from "../graphql";
import { wargameExerciseStatuses } from "../models";
import { usePollingQuery } from "../hooks";
export var ExercisePage = function (_a) {
    var _b;
    var id = _a.id;
    var _c = useWargameExercise(id), isLoading = _c.isLoading, warGameExerciseDetails = _c.warGameExerciseDetails, isExerciseBeingPrepared = _c.isExerciseBeingPrepared, activeWargames = _c.activeWargames, isActiveWargamesLoading = _c.isActiveWargamesLoading;
    var _d = __read(useState(false), 2), isImportWargamePlanVisible = _d[0], setIsImportWargamePlanVisible = _d[1];
    var showImportWargamePlan = function () { return setIsImportWargamePlanVisible(true); };
    var hideImportWargamePlan = function () { return setIsImportWargamePlanVisible(false); };
    if (isLoading || !warGameExerciseDetails) {
        return React.createElement(Spinner, { size: "medium" });
    }
    var isExecutionAllowed = warGameExerciseDetails.status ===
        wargameExerciseStatuses.executeExperiments.name;
    var isExecuteExperimentsVisible = warGameExerciseDetails.status ===
        wargameExerciseStatuses.prepareExperiments.name;
    var isExerciseActive = warGameExerciseDetails.status !== wargameExerciseStatuses.done.name &&
        warGameExerciseDetails.status !== wargameExerciseStatuses.cancelled.name;
    var isEmptyExerciseVisible = [
        wargameExerciseStatuses.todo.name,
        wargameExerciseStatuses.brainstormAndWalkthrough.name,
        wargameExerciseStatuses.cancelled.name
    ].includes(warGameExerciseDetails.status) ||
        (warGameExerciseDetails.status ===
            wargameExerciseStatuses.prepareExperiments.name &&
            isEmpty(warGameExerciseDetails.warGameTemplates));
    var content;
    if (isExerciseBeingPrepared) {
        content = React.createElement(ExerciseBeingPrepared, null);
    }
    else if (isEmptyExerciseVisible) {
        content = (React.createElement(EmptyExercise, { exerciseId: warGameExerciseDetails.id, exerciseStatus: warGameExerciseDetails.status, onImportPlan: showImportWargamePlan, confluencePage: warGameExerciseDetails.confluencePage, jiraUrl: warGameExerciseDetails.jiraTicket }));
    }
    else {
        content = (React.createElement(React.Fragment, null,
            React.createElement(WargamePlans, { wargamePlans: warGameExerciseDetails.warGameTemplates, wargameExerciseId: warGameExerciseDetails.id, onAddWargamePlan: showImportWargamePlan, isExecutionAllowed: isExecutionAllowed, isExerciseActive: isExerciseActive, isWargameActive: !isEmpty(activeWargames) }),
            React.createElement("br", null),
            React.createElement("br", null),
            isExecuteExperimentsVisible ? (React.createElement(ExecuteExperiments, { exerciseId: warGameExerciseDetails.id })) : (React.createElement(React.Fragment, null,
                React.createElement(ActiveWargameForWargameExercise, { serviceId: id, activeWargames: activeWargames, isLoading: isActiveWargamesLoading }),
                React.createElement("br", null),
                React.createElement("br", null),
                React.createElement(ExerciseExperiments, { jiraUrl: warGameExerciseDetails.jiraTicket }),
                React.createElement("br", null),
                React.createElement("br", null),
                React.createElement(RecentWargamesForExercise, { serviceId: id, wargameExerciseId: warGameExerciseDetails.id }),
                React.createElement("br", null),
                React.createElement("br", null)))));
    }
    return (React.createElement(Page, null,
        React.createElement(Grid, null,
            React.createElement(GridColumn, { medium: 12 },
                React.createElement(ExercisePageHeader, { id: warGameExerciseDetails.id, name: warGameExerciseDetails.name, status: warGameExerciseDetails.status, dueDate: warGameExerciseDetails.endDate, jiraUrl: warGameExerciseDetails.jiraTicket, confluenceUrl: warGameExerciseDetails.confluencePage, slackUrl: warGameExerciseDetails.slackChannel, zoomUrl: warGameExerciseDetails.zoomRoom, isExerciseBeingPrepared: isExerciseBeingPrepared }),
                React.createElement("br", null),
                !isExerciseBeingPrepared && (React.createElement(ExerciseProgressTracker, { currentStatus: warGameExerciseDetails.status })),
                React.createElement("br", null),
                React.createElement("br", null),
                content),
            React.createElement(ImportWargamePlan, { isVisible: isImportWargamePlanVisible, onHide: hideImportWargamePlan, serviceId: id, exerciseId: warGameExerciseDetails.id, existingWargamePlans: (_b = warGameExerciseDetails.warGameTemplates) !== null && _b !== void 0 ? _b : [] }))));
};
var useWargameExercise = function (serviceId) {
    var _a;
    var id = ReactRouter.useParams().id;
    var _b = useQuery(WargameExerciseMasterDataQuery, { variables: { id: id } }), data = _b.data, loading = _b.loading, startPolling = _b.startPolling, stopPolling = _b.stopPolling;
    var allAppsAvailable = Boolean((data === null || data === void 0 ? void 0 : data.warGameExerciseDetails.jiraTicket) && (data === null || data === void 0 ? void 0 : data.warGameExerciseDetails.slackChannel) &&
        data.warGameExerciseDetails.zoomRoom);
    var isExerciseBeingPrepared = !(data === null || data === void 0 ? void 0 : data.warGameExerciseDetails.jiraTicket);
    useEffect(function () {
        if (!allAppsAvailable) {
            startPolling(5000);
        }
        else {
            stopPolling();
        }
    }, [allAppsAvailable, startPolling, stopPolling]);
    var _c = usePollingQuery(WargamesInProgressQuery, {
        variables: { serviceId: serviceId }
    }), activeWargamesData = _c.data, isActiveWargamesLoading = _c.loading;
    var activeWargames = ((_a = activeWargamesData === null || activeWargamesData === void 0 ? void 0 : activeWargamesData.warGamesInProgressForService) !== null && _a !== void 0 ? _a : []).filter(function (activeWargame) { return activeWargame.wargameExercisesID === id; });
    return {
        isLoading: loading,
        warGameExerciseDetails: data === null || data === void 0 ? void 0 : data.warGameExerciseDetails,
        isExerciseBeingPrepared: isExerciseBeingPrepared,
        activeWargames: activeWargames,
        isActiveWargamesLoading: isActiveWargamesLoading
    };
};
